import deepFreeze from 'deep-freeze-strict';
import { assign, forEach, map } from 'lodash';
import { type } from '@mews-framework/utils';

export default function ContainerConfiguration() {
    const components = {};

    const containerConfiguration = Object.create(ContainerConfiguration.prototype);

    assign(containerConfiguration, {
        register(component: $TSFixMe, dependencyTypes = [], ...params: $TSFixMe[]) {
            type.checkType(component);
            checkNotRegistered(component.name);
            forEach(dependencyTypes, (t) => {
                type.checkType(t);
                // @ts-expect-error $TSFixMeError: Element implicitly has an 'any' type because expression of type 'any' can't be used to index type '{}'.
                if (!components[(t as $TSFixMe).name]) {
                    throw new Error(
                        `Dependent component is not registered yet: '${(t as $TSFixMe).name}' in '${component.name}'`
                    );
                }
            });
            // @ts-expect-error $TSFixMeError: Element implicitly has an 'any' type because expression of type 'any' can't be used to index type '{}'.
            components[component.name] = {
                component,
                params,
                dependencyTypes: map(dependencyTypes, (t) => (t as $TSFixMe).name),
            };
            return this;
        },
        extend(configuration: $TSFixMe) {
            type.check(configuration, ContainerConfiguration);
            forEach(configuration.components, (c, typeName) => {
                checkNotRegistered(typeName);
                // @ts-expect-error $TSFixMeError: Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{}'.
                components[typeName] = c;
            });
            return this;
        },
    });

    Object.defineProperty(containerConfiguration, 'components', {
        get() {
            return { ...components };
        },
    });

    return deepFreeze(containerConfiguration);

    function checkNotRegistered(typeName: $TSFixMe) {
        // @ts-expect-error $TSFixMeError: Element implicitly has an 'any' type because expression of type 'any' can't be used to index type '{}'.
        if (components[typeName]) {
            throw new Error(`Component is already registered: '${typeName}'`);
        }
    }
}
